import type { Components } from '@mui/material/styles';

export default function MuiCardActions(): Components['MuiCardActions'] {
  return {};
}
